// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__1W_Ae","icon":"styles_icon__uOTpY","info":"styles_info__3teQH","title":"styles_title__1h9ZV","body":"styles_body__31kI5"};